"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var portalBreadcrumbBaseTheme = function (_breakpoints) { return ({
    portalBreadcrumb: {
        separator: "chevron_right",
        fontSize: "inherit",
        marginLeft: "0",
        marginRight: "0"
    },
    portalBreadcrumbHref: {
        textDecoration: "none",
        display: "flex",
        "& i18n-message": {
            fontSize: "0.875rem",
        },
        userSelect: "none"
    },
}); };
exports.default = portalBreadcrumbBaseTheme;
//# sourceMappingURL=portalBreadcrumb.js.map